import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface MainPageLayoutProps {
    children: React.ReactNode;
}

const MainPageLayout: React.FC<MainPageLayoutProps> = ({ children }) => {
    return (
        <div className="main-page-layout">
            <Header />
            {children}
            <Footer />
        </div>
    );
};

export default MainPageLayout;
